import {
  removeLocalStorage,
  saveLocalStorage,
} from '../../../services/functions';
import { getTokenJwt } from '../../../services/functions';
import { getTimeStamp } from '../getTimeStamp';

const refreshToken = async () => {
  removeLocalStorage('token');
  saveLocalStorage('token', '');
  await getTokenJwt(true);
  getTimeStamp();
};

export default refreshToken;
